/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/7/30
 * Time: 09:38
 * Desc: 云店设置-其他
 */

import { Component, Vue } from 'vue-property-decorator';
import DistributeBoard from '@/views/components/distributeBoard/distributeBoard.vue'; // 虚拟店长佣金阈值
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import GuiderBoard from '@/views/components/guiderBoard';

@Component({
  components: {
    DistributeBoard,
    GuiderBoard,
    NoAuth,
  },
})
export default class DistributeList extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = true;

  public platformVersion = '';

  /* 方法 */
  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    localStorage.setItem('curpage', key);
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    //  this.getDomain();
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-DISTRIBUTE');
    if (this.isContentBodyShow) {
      // 获取当前页索引
      this.curPage = localStorage.getItem('curpage') ? localStorage.getItem('curpage') : this.$route.query.index ? this.$route.query.index.toString() : '1';
    }
  }

}
